import { render } from "./PaymentHistory.vue?vue&type=template&id=7f5c0929&ts=true"
import script from "./PaymentHistory.vue?vue&type=script&lang=ts"
export * from "./PaymentHistory.vue?vue&type=script&lang=ts"

import "./PaymentHistory.vue?vue&type=style&index=0&id=7f5c0929&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__